import { createAction, props } from '@ngrx/store';
import { ICurrentFasheet } from '../models/current-factsheet.model';

export const loadGetPreviousFactsheets = createAction('[GetPreviousFactsheet] Load GetPreviousFactsheets', props<{ request: string }>());

export const loadGetPreviousFactsheetsSuccess = createAction(
  '[GetPreviousFactsheet] Load GetPreviousFactsheets Success',
  props<{ response: ICurrentFasheet }>()
);

export const loadGetPreviousFactsheetsFailure = createAction(
  '[GetPreviousFactsheet] Load GetPreviousFactsheets Failure',
  props<{ error: Error | any }>()
);
